var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TeaserAccountTile',{attrs:{"title":_vm.$t('registrationSuccessfulPage.title'),"text":_vm.$t('registrationSuccessfulPage.text'),"primaryButtonText":_vm.$t('registrationSuccessfulPage.primaryButtonText'),"primaryButtonLink":_vm.url,"primaryButtonColor":"cta1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }